const CONSENT_KEY = 'cookie-consent';

/**
 * Reads the stored cookie consent data from localStorage and returns whether
 * analytics cookies have been consented to.
 *
 * This is intentionally a plain function (not a React hook) so it can be
 * used by non-component modules such as `src/services/analytics.ts`.
 */
export const hasAnalyticsConsent = (): boolean => {
  try {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (stored) {
      const data = JSON.parse(stored);
      return data.categories?.analytics === true;
    }
  } catch {
    // Silent error handling
  }
  return false;
};
